import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";

const TicketsQueueChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (data) {
      setChartData(
        data.map((item) => ({
          name: item.queue?.name || "Sin Departamento",
          value: parseInt(item.count),
          color: item.queue?.color || "#94a3b8",
        }))
      );
    }
  }, [data]);

  const totalValue = chartData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <div className="w-full h-full relative flex flex-col justify-center items-center">
      <div className="w-full h-64">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={55}
              outerRadius={75}
              paddingAngle={4}
              dataKey="value"
              strokeWidth={2}
              stroke="transparent"
            >
              {chartData.map((entry, i) => (
                <Cell key={`cell-${i}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                fontSize: "11px",
                color: "#1e293b"
              }}
            />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
              iconSize={6}
              wrapperStyle={{ fontSize: "10px", marginTop: "10px" }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      {totalValue > 0 && (
        <div className="absolute top-[37%] flex flex-col items-center justify-center pointer-events-none">
          <span className="text-[10px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">Total</span>
          <span className="text-xl font-extrabold text-slate-750 dark:text-slate-200">{totalValue}</span>
        </div>
      )}
    </div>
  );
};

export default TicketsQueueChart;

